import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
const names = ['Martín', 'Sofía', 'Lucas', 'Valentina', 'Facundo', 'Camila', 'Joaquín', 'Micaela', 'Agustín', 'Florencia'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Mar del Plata', 'La Plata', 'Tucumán', 'Salta', 'Santa Fe'];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setBuyer({
        name: randomName,
        city: randomCity
      });
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    const initialTimer = setTimeout(showPopup, 8000);
    const interval = setInterval(showPopup, 20000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-197">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 80,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 80
    }} transition={{
      type: 'spring',
      damping: 20,
      stiffness: 300
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 bg-zinc-900 border border-zinc-700 rounded-lg p-4 shadow-2xl flex items-center gap-4 z-50 max-w-xs" data-id="element-198">
          <div className="bg-[#F59E0B] p-2.5 rounded-full text-black flex-shrink-0" data-id="element-199">
            <ShoppingBagIcon size={20} data-id="element-200" />
          </div>
          <div data-id="element-201">
            <p className="text-sm font-bold text-white" data-id="element-202">
              {buyer.name} de {buyer.city}
            </p>
            <p className="text-xs text-zinc-400" data-id="element-203">
              Acaba de comprar este libro digital
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}